import { memo, useState } from "react";
import { useNavigate } from "react-router";
import { PasswordForgot } from "../../services/userService";
import { encryptPassword } from "../../helpers/formatter";
import { encryptionKey } from "../../constants/appConstant";
import "../../styles/pages/_forgetPassword.scss";

const ForgotPasswordVerification = () => {
  const [email, setEmail] = useState("");
  const [verificationCode, setVerificationCode] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [inputType, setInputType] = useState("password");
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState("");

  const navigate = useNavigate();

  const togglePassword = () => {
    setInputType(inputType === "password" ? "text" : "password");
  };

  const passwordVerificationHandler = async (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitted(true);
    setError("");

    if (!email || !verificationCode || !newPassword) {
      setError("All fields are required.");
      return;
    }

    try {
      const encryptedNewPassword = encryptPassword(newPassword, encryptionKey.key);
      await PasswordForgot({
        username: email,
        code: verificationCode,
        password: encryptedNewPassword,
      });

      // Optional redirect
      navigate("/login");
    } catch (err) {
      console.error(err);
      setError("Verification failed. Please try again.");
    }
  };

  return (
    <div className="login-wrapper min-vh-100 d-flex align-items-center justify-content-center">
      <div className="card-panel">
        {/* Left Panel */}
        <div className="left-panel d-none d-md-block">

          <img
            src="/assets/img/NewPassword.svg"
            alt="Reset Password Illustration"
            className="illustration-image"
          />
        </div>

        {/* Right Panel */}
        <div className="right-panel">
          <div className="form">
            <div className="logo">
              <img src="/assets/img/HOMEAID.svg" alt="HomeAid Logo" className="mb-3 logo" />
            </div>

            <div className="welcome-container">
              <p className="mb-0 welcome-text">
                Time for a new password! Make it something strong.
              </p>
              
            </div>

            <form onSubmit={passwordVerificationHandler}>
              {/* Verification Code */}
              <div className="floating-input mb-3 position-relative">
                <input
                  type="text"
                  id="verificationCode"
                  value={verificationCode}
                  onChange={(e) => setVerificationCode(e.target.value)}
                  required
                  placeholder="Enter verification code"
                  className={!verificationCode && submitted ? "is-invalid" : ""}
                />
                <label htmlFor="verificationCode">Verification Code</label>
                               {!verificationCode && submitted && (
                  <small className="text-danger">*Required</small>
                )}
              </div>

              {/* Email */}
              <div className="floating-input mb-3 position-relative">
                <input
                  type="email"
                  id="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  placeholder="Enter your email"
                  className={!email && submitted ? "is-invalid" : ""}
                />
                <label htmlFor="email">Email</label>
                <img src="/assets/img/mail_icon.svg" alt="Email icon" className="floating-icon" />
                {!email && submitted && (
                  <small className="text-danger">*Required</small>
                )}
              </div>

              {/* New Password */}
              <div className="floating-input mb-3 position-relative">
                <input
                  type={inputType}
                  id="newPassword"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  required
                  placeholder="Enter new password"
                  className={!newPassword && submitted ? "is-invalid" : ""}
                />
                <label htmlFor="newPassword">New Password</label>
                <img
                  src={`/assets/img/${inputType === "text" ? "eye_icon.svg" : "eye_close_icon.svg"}`}
                  alt="Toggle visibility"
                  className="floating-icon"
                  style={{ cursor: "pointer" }}
                  onClick={togglePassword}
                />
                {!newPassword && submitted && (
                  <small className="text-danger">*Required</small>
                )}
              </div>

              {/* Error */}
              {error && <div className="text-danger mb-2">{error}</div>}

              {/* Submit Button */}
              <button type="submit" className="btn-login">
                Submit
              </button>

              {/* Divider */}
              <div className="divider">
                <div className="divider-line"></div>
                <div className="divider-text">
                  <p className="mb-0">Or</p>
                </div>
                <div className="divider-line"></div>
              </div>

              {/* Back to Login */}
              <button
                type="button"
                className="btn-secondary w-100"
                onClick={() => navigate("/login")}
              >
                Click to Login
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default memo(ForgotPasswordVerification);
